export default __webpack_public_path__ + "static/media/facebookNoFill.a5823a40.svg";